import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';
import ResearchService from '@/service/industry-research';
import moIndex from '../../store';
import { cityAreaarr } from '../../component/city';

const moCompanyDistribution = observable({
  distributList: <any[]>[],
  type: 'city',
  mouseCtive: '',
});

// 获取公司总部分布数据
const getLocationDistribution = action((val?: string) => {
  const { type } = moCompanyDistribution;
  const param = {
    industry: moIndex.industry.code,
    type: val || type,
  };

  ResearchService.locationDistribution(param).then(res => {
    const arr = cloneDeep(res) || [];
    const newArr: any = [];
    arr?.forEach((item: any) => {
      newArr.push({
        city: item.city || item.city_grade || item.city_region || '',
        amount: item.count,
        active: false,
        city_list: [],
      });
    });
    newArr.map((item: any) => {
      if (item.city === '一线城市') {
        item.city_list = ['北京', '上海', '广州', '深圳'];
      } else if (item.city === '新一线城市') {
        item.city_list = [
          '天津', '沈阳', '南京', '无锡', '苏州', '杭州', '宁波', '青岛',
          '郑州', '武汉', '长沙', '东莞', '重庆', '成都', '西安',
        ];
      } else if (item.city === '二线城市') {
        item.city_list = [
          '石家庄', '太原', '大连', '长春', '哈尔滨', '常州', '合肥', '福州',
          '厦门', '南昌', '济南', '佛山', '南宁', '贵阳', '昆明',
        ];
      }
    });
    runInAction(() => { moCompanyDistribution.distributList = newArr; });
  });
});

// 获取公司总部分布数据
const initLocationDistribution = action((res: any) => {
  const arr = cloneDeep(res) || [];
  const newArr: any = [];

  moCompanyDistribution.type = localStorage.getItem('distributionType') || 'city';

  arr?.forEach((item: any) => {
    newArr.push({
      city: item.city || item.city_grade || item.city_region || '',
      amount: item.count,
      active: false,
      city_list: [],
    });
  });
  newArr.map((item: any) => {
    if (item.city === '一线城市') {
      item.city_list = ['北京', '上海', '广州', '深圳'];
    } else if (item.city === '新一线城市') {
      item.city_list = [
        '天津', '沈阳', '南京', '无锡', '苏州', '杭州', '宁波', '青岛',
        '郑州', '武汉', '长沙', '东莞', '重庆', '成都', '西安',
      ];
    } else if (item.city === '二线城市') {
      item.city_list = [
        '石家庄', '太原', '大连', '长春', '哈尔滨', '常州', '合肥', '福州',
        '厦门', '南昌', '济南', '佛山', '南宁', '贵阳', '昆明',
      ];
    }
  });
  runInAction(() => {
    moCompanyDistribution.distributList = newArr;

    getLocationDistribution();
  });
});

// 修改tab
const changeActiveType = action((val: string) => {
  getLocationDistribution(val);
  runInAction(() => {
    moCompanyDistribution.type = val;
    localStorage.setItem('distributionType', val);
  })
})

// 展示右边label

const getCurrentCity = action((val: string) => {
  moCompanyDistribution.mouseCtive = val;
});

// 当前类型
const getCurrentArea = action((val: string) => {
  const { distributList } = moCompanyDistribution;
  let value = '';
  distributList?.map(item => {
    item.city_list.map((child: any) => {
      if (child === val) value = item.city;
    });
  });
  moCompanyDistribution.mouseCtive = value;
});

// 当前区域
const getCurrentRegion = action((val: string) => {
  let value = '';
  cityAreaarr.map(item => {
    if (item.name === val) value = item.area;
  });
  moCompanyDistribution.mouseCtive = value;
});

// 恢复鼠标默认
const changeActive = action((val: string) => {
  moCompanyDistribution.mouseCtive = val;
});

export default moCompanyDistribution;

export {
  changeActiveType, getCurrentCity,
  getCurrentRegion, getCurrentArea, changeActive,
  getLocationDistribution, initLocationDistribution,
};
